import * as React from 'react';

const PhoneLink = () => {
    return (<a href="tel:+18588695502">858.869.5502</a>);
};

export default PhoneLink;
